import { render, staticRenderFns } from "./PtsBox.vue?vue&type=template&id=ddcd1e12&lang=pug"
import script from "./PtsBox.vue?vue&type=script&lang=js"
export * from "./PtsBox.vue?vue&type=script&lang=js"
import style0 from "./PtsBox.vue?vue&type=style&index=0&id=ddcd1e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports